/**
 * Summary
 * This component is responsible for displaying the current UTD granularity
 * as well as allowing the user to adjust said granularity level. It
 * should use the Select component to display the menu above itself.
 * Changes here should reflect immediately across the application,
 * triggering a re-render of the entire HistoryContainer. The 'steps' of
 * this menu should use the author-defined names for each period of time.
 */

import React, { useState, useEffect } from "react";

import { useTime } from "../../../_contexts";
import { Select } from "../../../_components";
import { ChronosDate } from "../../../_helpers";
import bigInt from "big-integer";

export function UTDSelector({ disabled, unitDisplayCount }) {
  console.log("UTD Selector: ", unitDisplayCount);
  const [options, setOptions] = useState([]);
  const {
    setGranularity,
    granularity: oldGranularity,
    calendar,
    currentDate,
    setCurrentDate,
    scrollPosition,
    updateScrollPosition,
  } = useTime();

  // console.log(calendar);
  const units = [
    "aeon",
    "epoch",
    "myriad",
    "millenium",
    "century",
    "decade",
    "year",
    "day",
    "hour",
    "minute",
  ];

  useEffect(() => {
    if (calendar) {
      let optionList = [];
      for (let unit of units) {
        const option = {
          value: unit,
          display: calendar.time[unit].plural,
        };
        optionList.push(option);
      }
      setOptions(optionList);
    }
  }, [calendar]);

  const handleSubmit = (newGranularity) => {
    // console.group(
    //   '[Chronos] Changed Granularity to: ',
    //   newGranularity,
    //   scrollPosition
    // );
    console.log("Current Date", currentDate);
    // const oldPosition = Math.floor(scrollPosition / 15);
    const date = new ChronosDate(currentDate, { calendar });
    console.log("Current ChronosDate", date.asString());
    const oldSegment = date.getTimelineSegment(oldGranularity, {
      unitCountDisplay: unitDisplayCount,
    });

    const oldDateStr = date.getDateFromPosition(
      scrollPosition,
      oldGranularity,
      oldSegment.start,
      unitDisplayCount
    );
    // console.warn('Date From Pos', oldDateStr, oldSegment);

    const oldDate = new ChronosDate(oldDateStr, { calendar });
    const newSegment = oldDate.getTimelineSegment(newGranularity, {
      unitCountDisplay: unitDisplayCount,
    });

    // const dateObject = oldDate.toFullObject();
    // console.warn('Date From Object', { ...dateObject });

    let unitsFromStart = 0;
    const advUnits = [
      "aeon",
      "epoch",
      "myriad",
      "millenium",
      "century",
      "decade",
      "year",
    ];

    if (advUnits.indexOf(newGranularity) > -1) {
      const yearsInUnit = bigInt(calendar.time[newGranularity].duration)
        .divide(calendar.time.year.duration)
        .toJSNumber();
      let diff = bigInt(oldDateStr)
        .abs()
        // .plus(1)
        .minus(bigInt(newSegment.start).abs())
        .abs();
      const unitsToCurrent = new ChronosDate(diff.toString()).toFullObject()
        .year;

      // console.warn('DIFF', diff);

      unitsFromStart = Math.abs(unitsToCurrent) / yearsInUnit;
    } else {
      // console.log('Checking::', oldDateStr, newSegment);

      let diff = bigInt(oldDateStr)
        .abs()
        .minus(bigInt(newSegment.start).abs())
        .abs();

      diff = diff.divide(calendar.time[newGranularity].duration);
      // console.log('Diff: after dividing by newGranularity', diff);
      diff = diff.mod(15 * unitDisplayCount).toJSNumber();
      unitsFromStart = diff;
    }

    console.log("Units from Start", unitsFromStart);

    const newPosition = unitsFromStart * 15;
    // console.log(
    //   'new position',
    //   newPosition,
    //   unitsFromStart,
    //   oldDateStr,
    //   dateObject,
    //   // oldSegmentStartDate,
    //   currentDate
    // );

    // console.groupEnd();

    // setCurrentDate(oldDateStr);
    setCurrentDate(newSegment.start);
    updateScrollPosition(Math.abs(newPosition));
    setGranularity(newGranularity);
  };
  return (
    <div className="chronos-chronicle-utd-selector-container">
      <Select
        options={options}
        showBullets
        defaultValue={oldGranularity}
        onChange={handleSubmit}
        title="Change Steps:"
        minWidth={120}
        disabled={disabled}
      />
    </div>
  );
}
